import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {
	createBrowserRouter, createRoutesFromElements, RouterProvider,
} from 'react-router-dom';

import { createBrowserHistory } from 'history';
import { loadableReady } from '@loadable/component';

import configureStore from '@common/react/configureStore';
import { BaseApplicationState } from '@common/react/store';
import { BaseUser } from '@common/react/objects/BaseUser';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
let store: any = null;

export const bootClient = <TUser extends BaseUser, TApplicationState extends BaseApplicationState<TUser>>(routes, reducers) => {
	const initialState = (window as any).initialReduxState as TApplicationState;

	store = configureStore<TUser, TApplicationState>(history, reducers, initialState);

	renderApp(routes);
};

export const getStore = () => store;

export const getHistory = () => history;

export const setStore = (newStore: any) => store = newStore;

export const renderApp = (routes) => {
	// This code starts up the React app when it runs in a browser. It sets up the routing configuration
	// and injects the app into a DOM element.
	if (getStore() === null) {
		throw 'bootClient must be called first!';
	}

	const router = createBrowserRouter(
		createRoutesFromElements(
			routes,
		),
	);

	loadableReady(() => {
		hydrateRoot(
			document.getElementById('react-app'),
			<Provider store={getStore()}>
				<RouterProvider router={router} />
			</Provider>,
		);
	});
};
